import {
  translateSingleString as remoteTranslateSingleString,
  translationDetails,
  trnsFormat,
} from '@paywithextend/localization'
import React from 'react'

export type TranslateFn = {
  (source: string, expressions?: Record<string, string>): string
  (
    source: string,
    expressions: Record<string, React.ReactNode>,
  ): React.ReactElement
}

export function createTranslate(
  localeTranslations: Record<string, translationDetails>,
  defaultTranslations: Record<string, translationDetails>,
): TranslateFn {
  const translateString = remoteTranslateSingleString(
    localeTranslations,
    defaultTranslations,
  )
  const translateRich = trnsFormat(localeTranslations, defaultTranslations)

  function translate(
    source: string,
    expressions?: Record<string, React.ReactNode>,
  ): string | React.ReactElement {
    if (
      !expressions ||
      Object.values(expressions).every((v) => typeof v === 'string')
    ) {
      return translateString(
        source,
        expressions as Record<string, string> | undefined,
      )
    }
    // trnsFormat only understands string | ReactElement interpolation values.
    // expressions is the broader ReactNode (numbers, booleans, arrays, null,
    // etc.), so wrap any non-string/non-element value in a Fragment instead of
    // unsafely casting it.
    const normalizedExpressions: Record<string, string | React.ReactElement> =
      {}
    for (const [key, value] of Object.entries(expressions)) {
      normalizedExpressions[key] =
        typeof value === 'string' || React.isValidElement(value)
          ? value
          : React.createElement(React.Fragment, null, value)
    }
    return React.createElement(
      React.Fragment,
      null,
      ...translateRich(source, normalizedExpressions),
    )
  }

  return translate as TranslateFn
}
